import Icon from '../../../components/AppIcon';
import { RatingStarsProps } from '../types';

const RatingStars = ({ rating, size = 20 }: RatingStarsProps) => {
  return (
    <div className="flex gap-1" aria-label={`Rating: ${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Icon
          key={star}
          name={star <= rating ? 'Star' : 'Star'}
          size={size}
          color={star <= rating ? '#fbbf24' : '#4b5563'}
          className={star <= rating ? 'fill-amber-400' : 'fill-gray-600'}
        />
      ))}
    </div>
  );
};

export default RatingStars;